import { render, staticRenderFns } from "./ReleaseNoteDownloadButton.vue?vue&type=template&id=6a9d0bf6&scoped=true&"
import script from "./ReleaseNoteDownloadButton.vue?vue&type=script&lang=ts&"
export * from "./ReleaseNoteDownloadButton.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseNoteDownloadButton.vue?vue&type=style&index=0&id=6a9d0bf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d0bf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
